import script from "./MyPoolBalancesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyPoolBalancesCard.vue?vue&type=script&setup=true&lang=ts"

import "./MyPoolBalancesCard.vue?vue&type=style&index=0&id=eb883618&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb883618"]])

export default __exports__